import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Page } from 'components';
import { Header, Results, SearchBar, Total } from './components';
import {
  AuthCheckJWT,
  GetCompany,
  // GetTransfer,
  GetMockTransfer
} from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, LinearProgress } from '@material-ui/core';
import _ from 'lodash';

const Transfer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const authen = useSelector(({ authen }) => authen);
  const isFetching = useSelector(({ transfer }) => transfer.isFetching);
  const transfer = useSelector(({ transfer }) => transfer.data);

  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    dispatch(AuthCheckJWT('/transfer'));
  }, [dispatch]);

  useEffect(() => {
    if (authen.isAuthenticated) {
      if (authen.loginUser.role === 'super') {
        dispatch(GetCompany());
      }
      dispatch(GetMockTransfer());
      // dispatch(GetTransfer());
    }
  }, [dispatch, authen]);

  useEffect(() => {
    if (transfer) {
      setTableData(
        searchText.length === 0
          ? transfer.data
          : filterArrayByKeyword(transfer.data, searchText)
      );
    }
  }, [transfer, searchText]);

  const filterArrayByKeyword = (data, keyword) => {
    if (keyword === '') return data;

    return _.filter(
      data,
      record =>
        record.amount.toUpperCase().includes(searchText.toUpperCase()) ||
        record.receiptName.toUpperCase().includes(searchText.toUpperCase()) ||
        record.receiptId.toUpperCase().includes(searchText.toUpperCase()) ||
        record.account.toUpperCase().includes(searchText.toUpperCase()) ||
        record.status.toUpperCase().includes(searchText.toUpperCase()) ||
        record.paid.toUpperCase().includes(searchText.toUpperCase())
    );
  };

  if (isFetching) {
    return (
      <Page
        className={classes.root}
        title="Transfer"
      >
        <div className={classes.loading}>
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            Loading...
          </Typography>
          <LinearProgress color="secondary" />
        </div>
      </Page>
    );
  }

  return (
    <Page
      className={classes.root}
      title="Transfer"
    >
      <Header />
      {transfer && (
        <>
          <Grid
            className={classes.container}
            container
            spacing={3}
          >
            <Grid
              item
              lg={12}
              xs={12}
            >
              <Total />
            </Grid>
          </Grid>
          <SearchBar
            onSearch={setSearchText}
            searchValue={searchText}
          />
          <Results
            className={classes.results}
            transfers={tableData}
          />
        </>
      )}
    </Page>
  );
};

export default Transfer;

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  },
  container: {
    marginTop: theme.spacing(0)
  },
  loading: {
    paddingTop: '25%',
    paddingLeft: '20%',
    paddingRight: '20%',
    flexGrow: 1,
    textAlign: 'center'
  }
}));
